<div class="aba-carteira">
  <div class="bloco-carteira">

    <div class="col">
      <div class="bloco-tipos-carteira">
        <a (click)="navigateTo('/obras/carteira')">
          <div class="item-header">
            <span>Carteira</span>
            <h2>Por obras</h2>
          </div>
          <p>Acompanhe as obras sob sua responsabilidade e as da equipe.</p>
        </a>
      </div>
    </div>

    <div class="linha" *ngIf="exibirCarteiraEmpresas"></div>

    <div class="col" *ngIf="exibirCarteiraEmpresas">
      <div class="bloco-tipos-carteira">
        <a (click)="navigateTo('/empresas/minha-carteira')">
          <div class="item-header">
            <span>Carteira</span>
            <h2>Por empresas</h2>
          </div>
          <p>Acompanhe as empresas salvas na sua carteira.</p>
        </a>
      </div>
    </div>

  </div>
</div>
